import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { useEffect, useState } from 'react';
import { badge } from './EventCalendar.Badge';
import { CalendarHeader } from './EventCalandar.Header';
import updateLocale from 'dayjs/plugin/updateLocale';
import { dateIndex } from 'utilities/utility.calendar';
import { current_language } from 'state/store.global';
import { useAtom } from 'jotai';

dayjs.extend(updateLocale);

export const EventCalendar = ({ showCalender, eventData, selectedEvent, setSelectedEvent }) => {

  const language = useAtom(current_language)[0];
  
  const [isLoading, setIsLoading]               = useState(false);
  const [highlightedDays, setHighlightedDays]   = useState([]);


  const fetchHighlightedDays = (ED) => {
     if (!eventData?.length) return

    setIsLoading(true)

    const daysToHighlight = ED.map((ed) => new dayjs(ed.FromDate))

    if (daysToHighlight.length > 0) {
      setHighlightedDays(daysToHighlight)
      setSelectedEvent(daysToHighlight[0])
      setIsLoading(false)
    }
  };

  useEffect(() => {
     if (eventData && eventData.length > 0) {
        fetchHighlightedDays(eventData);
      }
  }, [eventData]);


  return (
      showCalender && <DateCalendar
        value    = {selectedEvent}
        onChange = {(newValue) => {
          if(dateIndex(highlightedDays, newValue) >= 0) {
            setSelectedEvent(newValue)
          }
      }}
        loading               = {isLoading}
        renderLoading         = {() => <DayCalendarSkeleton />}
        disableHighlightToday = {true}
        slots                 = {{
          day           : badge,
          calendarHeader: CalendarHeader
        }}
        slotProps={{
          day: {
            highlightedDays,
            selectedEvent
          },
        }}
        dayOfWeekFormatter = {(date) => getDayNames(language, date)}
        sx                 = {{ background: '#fff', width: "100%", maxWidth: '300px', borderRadius: '6px', margin: 'unset', height: '271px',
           ".MuiDayCalendar-header": {
          padding: '24px 24px',
          span: {
            height: '13px',
            fontSize: '10px',

          }
        },
        ".MuiDayCalendar-monthContainer": {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        },
        ".MuiDayCalendar-weekContainer": {
          gap: '14px',
            "span": {
              width: '24px',
              height: '24px',
            },
            "button": {
              width: '24px',
              height: '24px',
              margin: 0,
              zIndex: 10
            }
          }
         }}
      />
  );
}

const getDayNames = (locale = 'da', date) => {
      // Set the desired locale dynamically
    dayjs.locale(locale);
      // Generate a list of day names based on the dynamic locale
    return dayjs(date['$d']).format('dddd').substring(0, 3)
  };
  